// export const parentAPI = "http://localhost/TenvicBase/Api/index.php/";
// export const parentAPI = "https://newapp.tenvicsports.com/backend/";
export const parentAPI = "https://samsara.tenvicsports.com/backend/";
// export const parentAPI = "http://localhost/backend/";


// Login
export const coreLogin = parentAPI + "account/core-login";
export const internalLogin = parentAPI + "account/internal-login";
export const institutionLogin = parentAPI + "account/institution-login";
export const refreshToken = parentAPI + "api/auth-refresh";

// Menu List
export const MenuList = parentAPI + "account/menu-List";

// Feature Access List
export const FeatureAccessList = parentAPI + "account/module-feature-access-list";

// Institution List 
export const InstitutionList = parentAPI + "institution/institutionList";

// admin group list
export const adminGroupList = parentAPI + "institution/institutionGroupList";

// admin type list
export const adminTypeList = parentAPI + "institution/institutionTypeList";

// update institute
export const updateInstitute = parentAPI + "institution/institutionUpdate";

// Nutritionist List 
export const NutritionistInstitutionList = parentAPI + "institution/getNutritionistInstitutions";

// Psychotherapist List
export const PsychotherapistInstitutionList = parentAPI + "institution/getPsychotherapistInstitutions";

// get nutritionist list
export const getNutritionistList = parentAPI + "institution/institutionNutritionistList";

// get physioTherapist list
export const GetPsychotherapistList = parentAPI + "institution/getInstitutionPhysiotherapistList";

// get therapist list
export const GetTherapist = parentAPI + "institution/institutionPhysiotherapList"; //InstitutionPhysiotherapist

// admin ops manager list
export const adminOpsMgrLst = parentAPI + "institution/institutionManagerList";

// unassigned manager for institutes (Inst List)
export const AsignOpsInstList = parentAPI + "institution/managersInstitutionList";

// Ops mgr list for assigning ops mgr for institutes
export const MgrList = parentAPI + "institution/managerList";

// Add Ops Manager for institute
export const SaveInstituteOpsManager = parentAPI + "institution/addManager";

// Update Ops Manager for institute
export const UpdateInstituteOpsManager = parentAPI + "institution/updateManager";

// admin sport coach list 
export const adminSportCoachList = parentAPI + "institution/sportCoachList";

// // Sport List
// export const SportList = parentAPI + "sports/sportList";

// Coach List for sport id
export const AssignCoachList = parentAPI + "account/coachList";

// check sport coach exist
export const CheckSportCoach = parentAPI + "institution/getCheckCoachSportExists";

// save sport coach
export const AddSportCoach = parentAPI + "institution/addSportCoach";

// Institution List
export const InstDd = parentAPI + "schedule/institutionByRole";

// skill list
// export const GetSkillDetails = parentAPI + "sports/skillList";

// Students List
export const StudentsList = parentAPI + "school/studentsList";

// Institution List
export const InstituteDd = parentAPI + "institution/institutionByCoachId";

// Program List 
export const ProgramList = parentAPI + "sports/programList";

// Batch List
export const BatchList = parentAPI + "school/batchList";

// Batch Details
export const BatchDetails = parentAPI + "school/batchesId";

// Batch Student List
export const BatchStudentList = parentAPI + "school/batchesStudentList";

// Coach List
export const CoachList = parentAPI + "school/batchesCoachList";

// Batches Student List 
export const BatchStudListMarked = parentAPI + "school/batchesStudentListMarked";

// Sport details Inst
export const SportDetailsInst = parentAPI + "school/detailsSportInst";

// batch student list
export const BatchStudents = parentAPI + "school/batchStudent";

// all batch list
export const getAllBatches = parentAPI + "school/exceptallBatchList";

// Archive Batch
export const ArchiveBatch = parentAPI + "school/archiveByBatchId";

// Duplicate Name
export const DuplicateName = parentAPI + "school/batchNamePresent";

// Create Batch
export const CreateBatch = parentAPI + "school/batchesCreate";

// Update Batch
export const updateBatchStudent = parentAPI + "school/studentBatchesCreate";

// swap batches sport list
export const getSBSportList = parentAPI + "school/sportDisplay";

// swap batches all batch list
export const getSBBatchList = parentAPI + "school/allBatchList";

// swap batches students list
export const getSBStudentList = parentAPI + "school/detailsOfStudent";

// swap batch
export const swapFullBatch = parentAPI + "school/swapBatchesCreate";

// List Batches
export const ListBatches = parentAPI + "school/batchByCoachId";

// List Schedules
export const listSchedules = parentAPI + "schedule/scheduledBatchList";

// Schedule Type
export const ScheduleTypes = parentAPI + "schedule/scheduleTypes";

// Archive Schedule
export const archiveSchedule = parentAPI + "schedule/archiveByScheduleId";

// Skill Set List 
export const ListSkillSet = parentAPI + "schedule/skillByCoachId";

// Create Schedule
export const CreateSchedule = parentAPI + "schedule/scheduleBatchCreate";

// Grade List
export const GradeList = parentAPI + "schedule/gradesList";

// Attendance Type List 
export const AttendanceTypeList = parentAPI + "schedule/attendanceList";

// Batch List for attendance marking
export const BatchByInstitution = parentAPI + "school/batchByInstitution";

// Attendance List
export const AttendanceList = parentAPI + "school/attendanceFullList";

// Batch Attendance List
export const BatchAttendanceList = parentAPI + "school/studentListByScheduleId";

// Schedule By Institution
export const ScheduleByInstitution = parentAPI + "schedule/scheduleByInstitution";

// Attendance Student List
// export const AttendanceStudentList = parentAPI + "AttendancesController/StudentList";
export const AttendanceStudentList = parentAPI + "school/studentList";


// refresh token
export const RefreshToken = parentAPI + "api/auth-refresh";



// update group
export const UpdateGroup = parentAPI + "institution/institutionGroupUpdate";

// add group
export const AddGroup = parentAPI + "institution/institutionGroupCreate";

// add type
export const AddType = parentAPI + "institution/institutionTypeCreate";

// update type
export const UpdateType = parentAPI + "institution/institutionTypeUpdate";

// create institute
export const createInstitute = parentAPI + "institution/institutionCreate";




// Sport List
export const SportList = parentAPI + "sports/sportList";
// export const SportList = parentAPI + "SportController/sportNameList";  *Both same API*
// check sport name exists
export const CheckSportName = parentAPI + "sports/sportNamePresent";
// createSport
export const CreateSport = parentAPI + "sports/sportCreate";
// update sport
export const UpdateSport = parentAPI + "sports/sportUpdate";
// Sport Skill List
export const SportSkillList = parentAPI + "sports/sportSkillList";
// edit skill details
export const GetSkillDetails = parentAPI + "sports/skillList";
// Programs List
export const ProgramsList = parentAPI + "sports/programList";
// export const ProgramList = parentAPI + "SportController/programNameList"; *Both same API*
// create program
export const CreateProgram = parentAPI + "sports/programCreate";
// update program
export const UpdateProgram = parentAPI + "sports/programUpdate";
// reference sport list
export const ReferenceSport = parentAPI + "sports/referenceSport";
// reference link
export const ReferenceLink = parentAPI + "tutorial/referenceLink";




// Institute Type List
export const InstituteTypeList = parentAPI + "generalreports/instituteTypeList";
// Report Institution List 
export const GetReportInstitutions = parentAPI + "generalreports/getInstitutions";
// assessment batch list
export const GetBatchAssessment = parentAPI + "generalreports/getBatchAssessment";
// assessment list
export const GetAssessment = parentAPI + "generalreports/getAssessment";
// assessment report
export const GetAssessmentReport = parentAPI + "generalreports/getAssessmentReport";
// view assessment report 
export const ReportAssessmentData = parentAPI + "generalreports/reportAssessmentData";
// assessment report export
export const AssessmentReportExport = parentAPI + "generalreports/getAssessmentReportExport";
// coach list
export const GetCoachList = parentAPI + "generalreports/getCoach";
// report batch list
export const GetRprtBatchList = parentAPI + "generalreports/getBatch";
// attendance report 
export const GetAttendanceReport = parentAPI + "generalreports/getAttendanceReport";
// report attendance details
export const GetReportAttendanceDetails = parentAPI + "generalreports/reportAttendance";
// attendance report export
export const AttendanceReportExport = parentAPI + "generalreports/attendancereportExport";
// institute Details
export const GetInstituteDetails = parentAPI + "generalreports/displayDetailsInst";
// Status Report 
export const GetStatusReport = parentAPI + "generalreports/displayStatusReport";
// general institute list
export const GeneralInstituteList = parentAPI + "generalreports/generalInstitutionList";
// get class list
export const GetClass = parentAPI + "generalreports/getClass";
// get section list 
export const GetSection = parentAPI + "generalreports/getSectionByClass";
// get student report
export const GetStudentReport = parentAPI + "generalreports/studentDetails";
// sports type list
export const SportsTypeList = parentAPI + "generalreports/sportrsTypeList";
// institution sports data
export const GetInstitutionSportsData = parentAPI + "generalreports/getInstitutionSportsData";
// institution sports data export
export const SportsNameExportToExcel = parentAPI + "generalreports/sportsNameExportToExcel";
// institution status report export
export const InstitutionStatusExport = parentAPI + "generalreports/exportdisplayStatusReport";
// institute report export
export const InstituteReportExport = parentAPI + "generalreports/exportinstituteReport";
// student Report export
export const StudentReportExport = parentAPI + "generalreports/exportStudentDetails";



// Inventory Institutions
export const InvenInstitutions = parentAPI + "inventory/institutionList";
// Goods List 
export const GoodsList = parentAPI + "inventory/goodsList";
// Stock List
export const StockList = parentAPI + "inventory/stockList";
// Vendor List
export const VendorList = parentAPI + "inventory/vendorList";
// Product List 
export const ProductList = parentAPI + "inventory/productList";
// Create Category
export const CategoryCreate = parentAPI + "inventory/categoryCreate";
// Update Category
export const UpdateCategory = parentAPI + "inventory/categoryUpdate";
// Category List
export const CategoryList = parentAPI + "inventory/categoryList";
// Inventory Sport List
export const InventorySportList = parentAPI + "inventory/sportsList";
// goods sports list
export const goodsSportsById = parentAPI + "inventory/sportById";
// coaches by sports id
export const coachesBySportId = parentAPI + "inventory/coachById";
// products by sports id
export const productsBySportsId = parentAPI + "inventory/productBySport";
// save issue goods
export const saveIssueGoods = parentAPI + "inventory/issueGoods";
// return Goods
export const returnGoods = parentAPI + "inventory/returnGoods";


// video name by sport
export const VideoNameBySport = parentAPI + "tutorial/videoNameById";
// document list
export const DocumentList = parentAPI + "tutorial/documentList";


// support case list
export const supportCaseList = parentAPI + "support/supportCaseList";

// save student
export const SaveStudent = parentAPI + "school/studentCreate";

// add student to batch
export const AddStudentToBatch = parentAPI + "school/studentToBatch";


// admin schedule list
export const adminScheduleList = parentAPI + "schedule/scheduleList";
// admin schedule details
export const adminScheduleDetails = parentAPI + "schedule/getSchedule";
// admin schedule update
export const adminScheduleUpdate = parentAPI + "schedule/scheduleUpdate";
// admin attendance list
export const adminAttendanceList = parentAPI + "schedule/attendanceList";
// admin attendance details
export const adminAttendanceDetails = parentAPI + "schedule/attendanceList";  //"schedule/getAttendance";
// admin attendance update
export const adminAttendanceUpdate = parentAPI + "schedule/attendanceUpdate";
// admin grade list
export const adminGradeList = parentAPI + "schedule/gradeList";
// admin grade details
export const adminGradeUpdateDetails = parentAPI + "schedule/gradeList";//"scheduleAttendanceController/gradeUpdateData";
// admin grade update
export const adminGradeUpdate = parentAPI + "schedule/gradeUpdate";
// admin assessment list
export const adminAssessmentList = parentAPI + "schedule/assessmentList";
// admin assessment details
export const adminAssessmentData = parentAPI + "schedule/getAssessment";
// admin assessment update
export const adminAssessmentUpdate = parentAPI + "schedule/assessmentUpdate";
// admin cc skill list
export const adminCcSkillsList = parentAPI + "schedule/ccSkillList";
// admin cc skill details
export const adminCcSkillsData = parentAPI + "schedule/getCcSkill";
// admin cc skill update
export const adminCcSkillsUpdate = parentAPI + "schedule/ccskillUpdate";


// // ins count
export const instStudCounts = parentAPI + "analytics/getInstitutionStudentCount";
// // ins count by sport
export const instStudCountSprt = parentAPI + "analytics/getInstitutionStudentCountBySport";
// ins count by year
export const instCountByYear = parentAPI + "analytics/getInstitutionByYear";
// ins count by month
export const insCountByMonth = parentAPI + "analytics/getSessionByMonth";


// admin schedule create
export const adminScheduleCreate = parentAPI + "schedule/scheduleCreate";
// admin attendance create
export const adminAttendanceCreate = parentAPI + "schedule/attendanceCreate";
// admin grade create
export const adminGradeCreate = parentAPI + "schedule/gradeCreate";
// admin assessment create
export const adminAssessmentCreate = parentAPI + "schedule/assessmentCreate";
// admin cc skill create
export const adminCcSkillsCreate = parentAPI + "schedule/ccskillCreate";
// skill create
export const skillCreate = parentAPI + "sports/skillCreate";
// skill update
export const skillUpdate = parentAPI + "sports/skillUpdate";
// category by sport id
export const CategoryBySport = parentAPI + "inventory/categoryBySport";
// create vendor
export const CreateVendor = parentAPI + "inventory/vendorCreate";
// update vendor
export const UpdateVendor = parentAPI + "inventory/vendorUpdate";
// create product
export const CreateProduct = parentAPI + "inventory/productCreate";
// update product
export const UpdateProduct = parentAPI + "inventory/productUpdate";
// update stock
export const UpdateStock = parentAPI + "inventory/stockUpdate";
// update stock quantity
export const UpdateStockQuantity = parentAPI + "inventory/stockQuantityUpdate";
// create stock
export const CreateStock = parentAPI + "inventory/stockCreate";
// vendor by product
export const VendorByProduct = parentAPI + "inventory/vendorByProduct";
// check user name 
export const CheckUserName = parentAPI + "account/checkUsername";
// check user email
export const CheckUserEmail = parentAPI + "account/checkUserEmail";
// get forgot password link
export const ForgotPasswordLink = parentAPI + "account/getRequestForgotPasswordLink";
// verify password link
export const VerifyPasswordReset = parentAPI + "account/getVerifyPasswordReset";
// reset password
export const ResetPassword = parentAPI + "account/getResetPassword";
// sport coach edit
export const SportCoachEdit = parentAPI + "institution/editSportCoach";
// get student list for class and section
export const GetClassStudents = parentAPI + "school/listStudentByClassAndSection";
// Update Schedule
export const ScheduleUpdate = parentAPI + "schedule/scheduleBatchUpdate";

// Metric Scale
export const MetricScale = parentAPI + "metric/metricscale";

// Metric Data
export const MetricData = parentAPI + "metric/metricdata";

// Daily Check-in
export const DailyCheckin = parentAPI + "metric/dailycheckin";

// hpc athletes
export const HPCAthletes = parentAPI + "metric/listathlete";